export enum SectionColumnConfigCollectiveCannabinoidKey {
  // TODO - KFFT - eventually add TotalCannabinoids (TAC) here?
  TopCannabinoid = 'TopCannabinoid',
  ListCannabinoids = 'ListCannabinoids'
}
